// Partners with a co-branded landing page at /partners/<slug>.
// Slugs must match REFERRAL_PARTNERS in dexter-api — they are sent with the signup
// request and stored on user.referredByPartner.
export const REFERRAL_PARTNERS = {
  vituity: { name: 'Vituity', logo: 'vituity_logo.png' },
}

export const isReferralPartner = (slug) =>
  Object.prototype.hasOwnProperty.call(REFERRAL_PARTNERS, slug)
